<!--  -->
<template>
  <div id="region">
        <div class="fanhui" @click="$router.push('/home')">
            <img src="../../assets/ggimg/fh.png" alt="">
        </div>
        <div class="fenxiangs" @click="fenxiang">
            <img class="rightImg" src="../../assets/xlogo/fx.png" alt="">
        </div>
      <Head></Head>
      <div class="main">
          <div class="zhanwei"></div>
          <ul class="ul1">
              <li v-for="item in hbdq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
          <ul class="ul2">
              <li v-for="item in dbdq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
          <ul class="ul3">
              <li v-for="item in hddq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
          <ul class="ul4">
              <li v-for="item in hzdq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
          <ul class="ul5">
              <li v-for="item in hndq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
          <ul class="ul6">
              <li v-for="item in xbdq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
          <ul class="ul7">
              <li v-for="item in xndq" :key="item.name" @click="diqu(item.name)">
              </li>
          </ul>
      </div>
      <!-- <router-view></router-view> -->
  </div>
</template>

<script>
// eslint-disable-next-line no-irregular-whitespace
/* eslint-disable no-undef */
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Head from '../../components/head'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
      Head
    },
  data() {
    //这里存放数据
    return {
        hbdq:[{name:'北京'},{name:'天津'},{name:'河北'},{name:'内蒙古'},{name:'山西'}],
        dbdq:[{name:'黑龙江'},{name:'辽宁'},{name:'吉林'}],
        hddq:[{name:'江苏'},{name:'山东'},{name:'青岛'},{name:'福建'},{name:'安徽'},{name:'厦门'},{name:'宁波'},{name:'浙江'},{name:'江西'},{name:'上海'}],
        hzdq:[{name:'湖北'},{name:'河南'},{name:'湖南'}],
        hndq:[{name:'深圳'},{name:'广西'},{name:'海南'},{name:'广东'},],
        xbdq:[{name:'宁夏'},{name:'甘肃'},{name:'陕西'},{name:'新疆'},{name:'青海'}],
        xndq:[{name:'云南'},{name:'四川'},{name:'贵州'},{name:'重庆'},{name:'西藏'}],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getUrlParam(channel){
        var reg = new RegExp("(^|&)" + channel + "=([^&]*)(&|$)");
        var r = window.location.search.slice(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    fenxiang(){
        upsdk.ready(function(){ 
            upsdk.setNavigationBarTitle( {title:'银联优惠日'})
            upsdk.showSharePopup({
                title:'银联优惠日 相约6+2',
                desc:'天天抽红包 周周享优惠',
                shareUrl:window.location.href,
                picUrl:'https://i.ibb.co/HqtMYLB/logo.jpg'
            })    
        });
        upsdk.error(function(err){
        //config信息验证失败会执行error方法  
        console.log(err);
        });
    },
    diqu(name){
        // console.log(name);
        if(name == '云南'){
            window.location.href="https://article.95516.com/eq/ls/t0cd4jLk.html";  
        }else{
            this.$router.push({
                path: `/details/${name}`,
            })
        }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const u = navigator.userAgent;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if(isIOS){
      this.$axios({
          method: 'post',
          // url:"https://quickbuy.95516.com/sftest/szjq/user/initUpsdk",
          url:"https://coupon.unionpay.com/gw/common/initUpsdk",
          params: {
              url:window.location.href,
          }
      }).then((res)=>{
          // console.log(res);
          var post = res.data.respParams;
          console.log(post);
          upsdk.config({
              appId:post.appId,   //必填，接入方的唯一标识，由云闪付分配
              timestamp:post.timestamp,   //必填，生成签名的时间戳，从1970年1月1日00:00:00至今的秒数，取东八区的北京时间，例1556096162
              nonceStr:post.nonceStr,    //必填，生成签名的随机串，参见附录三生成签名随机字符串
              signature:post.signature,   //必填，生成签名的摘要，参见附录一、附录二
              debug: false   //开发阶段可打开此标记，云闪付APP会将调试信息toast出来
          });
      });
    }
    const result = this.getUrlParam('channel');
    this.$axios({
        method: 'post',
        url:'https://coupon.unionpay.com/gw/point/saveUserClickMsg',
        params: {
        customerId:'1',
        appId: 'yhr3',
        clickId: result,
        url:'https://coupon.unionpay.com/yinlianyouhuiri/region/?channel=' + result,
        }
        }).then((res) =>{
            console.log(res);
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    #region{
        position: relative;
        .fenxiangs{
            position: absolute;
            right: 0px;
            top: 42px;
            z-index: 1000;
            width: 115px;
            height: 115px;
            .rightImg{
                width: 115px;
                height: 49px;
                margin-top: 10px;
            }
        }
    }
    .fanhui{
        position: absolute;
        left: 0;
        top: 868px;
        z-index: 100;
        img{
            width: 266px;
            height:103px ;
        }
    }
.main{
    width: 100%;
    // height: 5124px;
    background: url("../../assets/ggimg/qgbj.png")no-repeat;
    background-size: 100% 100%;
    margin-top: -200px;
    padding-bottom: 80px;
    .zhanwei{
        height: 180px;
    }
    .ul1{
        width: 727px;
        height: 700px;
        background: url("../../assets/xlogo/hbdq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 160px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 50%;
        }
    }
    .ul2{
        width: 727px;
        height: 507px;
        background: url("../../assets/xlogo/dbdq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 110px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 100%;
        }
    }
    .ul3{
        width: 727px;
        height: 1056px;
        background: url("../../assets/xlogo/hddq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 120px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 25%;
        }
    }
    .ul4{
        width: 727px;
        height: 500px;
        background: url("../../assets/xlogo/hzdq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 140px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 100%;
        }
    }
    .ul5{
        width: 727px;
        height: 695px;
        background: url("../../assets/xlogo/hndq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 140px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 50%;
        }
    }
    .ul6{
        width: 727px;
        height: 672px;
        background: url("../../assets/xlogo/xbdq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 140px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 50%;
        }
    }
    .ul7{
        width: 727px;
        height: 700px;
        background: url("../../assets/xlogo/xndq.png")no-repeat;
        background-size: 100% 100%; 
        margin: 80px auto;
        padding: 194px 80px 140px 80px;   
        box-sizing:border-box;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 33%;
            height: 50%;
        }
    }
}
</style>